import React from "react";
import { Tooltip } from "primereact/tooltip";
import { toast } from "react-toastify";
import moment from "moment";

export const formatNumber = (value) => {
  return value !== null && value !== undefined ? value.toLocaleString() : "--";
};

export const formatDate = (dateString, showTime = true) => {
  if (!dateString) return "--";

  const m = moment(dateString);
  const date = m.format("MMMM Do YYYY");
  const time = m.format("h:mm A");

  return showTime ? (
    <div>
      {date} ({time})
    </div>
  ) : (
    date
  );
};

export const formatTo12Hour = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Invalid Date"; // Return a placeholder for invalid date
  }

  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true, // 12-hour format
  };
  const formattedDate = date.toLocaleString("en-US", options);
  return formattedDate;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatCapitalizeFirstLetter = (rowData, field) => {
  if (!rowData || rowData[field] === undefined || rowData[field] === null) {
    return "";
  }

  return capitalizeFirstLetter(rowData[field]);
};

